import type { EstimateSplitMode } from "../views/Orders/services/EstimateAllocatorService/types";

const endpoints = {
  getOTP: (visitId: string, phoneNumber: string, mobileNumberPrefix: string) =>
    `/otp/?visitId=${visitId}&mobileNumber=${mobileNumberPrefix}${phoneNumber}`,
  visitId: "/visits",
  verifyOTP: (mobileNumber: string, otp: string, mobileNumberPrefix: string) =>
    `/otp/verify?mobileNumber=${mobileNumberPrefix}${mobileNumber}&otp=${otp}&role=ORCA_ADMIN`,
  placeOrder: "/orders",
  getGaraazOrder: (orderId: any) => `v1/orders/${orderId}`,
  cancelGaraazOrder: (orderId: any) => `v1/orders/${orderId}/cancel`,
  getOrderStatsByOrderHandler: `v1/order-handler/stats`,
  getOrderHandlerStats: (orderHandlerId: string) =>
    `v1/order-handler/stats?orderHandlerId=${orderHandlerId}`,
  allocateSupplierGaraazOrder: (orderId: any) =>
    `v1/orders/${orderId}/allocate`,
  garaazOrderCBO: (orderId: any) => `v1/orders/${orderId}/CBO`,
  placeGaraazOrder: "/v1/orders",
  getXpressCustomer: (search: string) =>
    `/v1/customers?search=${search}&isXpress=true`,
  getActiveSubscriptionCustomers: `/v1/customers?subscriptions=active`,
  addMedia: "/media",
  deleteMedia: (mediaId: string) => `/media/${mediaId}`,
  mobileConfig: "/mobile/config",
  searchXpressCustomer: `/v1/customers?isXpress=true&search=`,
  getAllGaraazOrdersV3: "/v3/orders/family/children?responseMode=rootsOnly",
  getAllGaraazOrders: "/v2/orders?isPopulated=true",
  getR2DOrders: "/v2/orders",
  getChildOrders: (orderId: string) => `/v3/orders/${orderId}/children?`,
  setOrderRemarks: (orderId: string) => `/v1/orders/${orderId}/orderRemarks`,
  setOrderRemarksByOrderNo: (orderNo: string) =>
    `/v1/orders/${orderNo}/orderRemarks`,

  setOrderETA: (orderId: string) => `/v1/orders/${orderId}/orderETA`,
  getMyEtaHardLocks: `/v1/eta-alerts/me/hard-locks`,
  createPaymentLink: (orderId: string) => `/v1/orders/${orderId}/payment-links`,
  mergeOrder: (orderNo: string) => `/v1/orders/${orderNo}/merge`,
  updateOrDeleteOrder: (orderId: string) => `/v1/orders/${orderId}`,
  deleteOrder: (orderNo: string) => `v2/orders/${encodeURIComponent(orderNo)}`,
  updateOrderMetaInfo: (orderId: string) => `/v1/orders/${orderId}/meta-info`,
  insertOrUpdateGaraazOrderItemsPart: (orderId: string) =>
    `/orders/${orderId}/orderItems`,
  deleteGaraazOrderPart: (orderId: string) => `/orders/${orderId}/orderItems`,
  getSearchedPartListBulk: (
    parts: { partNumber: string; orderedQuantity: number }[],
  ) =>
    `/part/get-product-by-code-bulk/${parts
      .map((part) => part.partNumber)
      .join(",")}`,
  getSearchedPartList: (partNumber: string) =>
    `/part/get-product-by-code/${partNumber}`,
  getOrderHandlers: `/v1/grazeons/order-handlers`,
  getAllOrderHandlers: `/v1/users?userType=GARAAZ_PERSONNEL&userSubType=ORDER_HANDLER`,
  getInsuranceUsers: (userSubType: "SPOC" | "SURVEYOR") =>
    `/v1/users?userType=INSURANCE&userSubType=${userSubType}`,
  getAllSuppliersV2: "/v2/suppliers?isPopulated=true",
  getBrands: "/v1/brands",
  getMediaById: (id: string) => `/media/${id}`,
  missedEta: (orderId: any) => `/v1/orders/${orderId}/etaMissed`,
  missedAck: (orderId: any) => `/v1/orders/${orderId}/ackMissed`,
  missedETAProvide: (orderId: any) => `/v1/orders/${orderId}/etaProvideMissed`,
  exportOrderDetailsAsCsv: (orderId: any) =>
    `/v1/orders/${orderId}/export?option=csv`,
  getCars: `/v1/cars`,
  getCarById: (carId: any) => `/v1/cars/${carId}`,
  getSparePartInfo: (partId: any) => `/v1/spare-part/${partId}`,
  getIframe: `/output/index.html`,
  getCarPartDetails: (carId: any) => `/v1/cars/${carId}/parts`,
  missingCarPartInformation: (carId: any) =>
    `v1/cars/${carId}/missing-part-information`,
  getActiveGenerations: `v1/cars/generations`,
  addCarSparePartRequest: "/v1/car-spare-part-requests",
  verifyCarPart: (carId: any, UPN: string, partNumber: string) =>
    `/v1/cars/${carId}/parts/${UPN}/${partNumber}/verify`,
  unVerifyCarPart: (carId: any, UPN: string, partNumber: string) =>
    `/v1/cars/${carId}/parts/${UPN}/${partNumber}/unverify`,
  fetchModels: "/v1/cars/models",
  fetchMakers: "/v1/cars/makers",
  fetchGenerations: "/v1/cars/generations",
  getCarMakers: () => "/v1/vehicle-tree/maker",
  getModelLines: (makerId: string) =>
    `/v1/vehicle-tree/line?makerId=${makerId}`,
  getCarYears: (lineId: string, makerId: string) =>
    `/v1/vehicle-tree/configuration?lineId=${lineId}&makerId=${makerId}`,
  getCarModifications: (lineId: string, year: string, makerId: string) =>
    `/v1/vehicle-tree/configuration?lineId=${lineId}&year=${year}&makerId=${makerId}`,
  getCustomerAllSubscriptions: (customerId: string) =>
    `/v1/customers/${customerId}/subscriptions/`,
  getUniqueCustomer: "/v1/metrics/customers/unique",
  upsertPhantomFeedback: "/v1/order-phantom-feedback",
  getDistinctCustomerStates: "/v1/customers/unique-states",
  receivePayment: `/v2/payments/received`,
  createShipment: "/v1/shipments",
  createReturnOrder: (orderNo: string) => `/v1/orders/${orderNo}/return`,
  getVehicleByLPN: (lpn: string) => `/v1/search-vehicle/${lpn}`,
  updateVehicleByLPN: (lpn: string) => `/v1/vehicle/${lpn}`,
  getGrazeons: "/v1/grazeons",
  updateShipment: (shipmentId: string) => `/v1/shipments/${shipmentId}`,
  fetchDeliveryOptions: (orderNo: string) =>
    `/v1/estimate/${orderNo}/delivery-options`,
  createManualDeliveryOption: (estimateNo: string, splitId: string) =>
    `/v1/estimate/${estimateNo}/splits/${splitId}/delivery-options`,
  confirmEstimateSplit: (
    estimateNo: string,
    splitId: string,
    mode?: EstimateSplitMode,
  ) =>
    `/v1/estimate/${estimateNo}/splits/${splitId}/confirm${
      mode ? `?mode=${mode}` : ""
    }`,
  cancelEstimateSplit: (
    estimateNo: string,
    splitId: string,
    mode?: EstimateSplitMode,
  ) =>
    `/v1/estimate/${estimateNo}/splits/${splitId}/cancel${
      mode ? `?mode=${mode}` : ""
    }`,
  holdEstimateSplit: (
    estimateNo: string,
    splitId: string,
    mode?: EstimateSplitMode,
  ) =>
    `/v1/estimate/${estimateNo}/splits/${splitId}/hold${
      mode ? `?mode=${mode}` : ""
    }`,
  shareEstimate: (estimateNo: string) => `/v1/estimate/${estimateNo}/share`,
  patchEstimate: (estimateNo: string) => `/v1/estimate/${estimateNo}`,
  patchEstimateSplit: (estimateNo: string, splitId: string) =>
    `/v1/estimate/${estimateNo}/splits/${splitId}`,
  syncEstimateSplitsItems: (estimateNo: string) =>
    `/v1/estimate/${estimateNo}/splits-items`,
  deleteDeliveryOptionInEstimateSplit: (
    estimateNo: string,
    splitId: string,
    optionId: string,
  ) =>
    `/v1/estimate/${estimateNo}/splits/${splitId}/delivery-options/${optionId}`,
  orderItemsAction: (orderNo: string, mode?: EstimateSplitMode) =>
    `/v1/orders/${orderNo}/order-items${mode ? `?mode=${mode}` : ""}`,
  getStateCity: "/utility/state-city",
  getInsurers: "/v1/customers/insurers",
  getSupplierPartAvailability: (requestId: string, partIds?: string[]) => {
    const safeRequestId = encodeURIComponent(requestId);
    const path = `/v1/supplier-inventory/${safeRequestId}/supplier-part-availability`;
    if (partIds?.length) {
      const query = partIds
        .map((id) => `partIds=${encodeURIComponent(id)}`)
        .join("&");
      return `${path}?${query}`;
    }
    return path;
  },
  createPartConfirmation: `/v1/part-confirmations`,
  getPartConfirmationRequests: (orderNo: string) =>
    `/v1/part-confirmations/requests?orderNo=${encodeURIComponent(orderNo)}`,
  revokePartConfirmation: (requestId: string) =>
    `/v1/part-confirmations/${encodeURIComponent(requestId)}/revoked`,
  getPartConfirmationResponses: (orderNo: string, supplierId: string) =>
    `/v1/part-confirmations?orderNo=${encodeURIComponent(
      orderNo,
    )}&supplierId=${encodeURIComponent(supplierId)}`,
  listPartConfirmationsForOrder: (orderNo: string) =>
    `/v1/part-confirmations?orderNo=${encodeURIComponent(orderNo)}`,
  getSupplierInventoryDeltas: (rootPartNumbers: string[]) => {
    const query = rootPartNumbers
      .map(
        (rootPartNumber) =>
          `rootPartNumber=${encodeURIComponent(rootPartNumber)}`,
      )
      .join("&");
    return `/v1/supplier-inventory/deltas?${query}`;
  },
  getCboByPartNumbers: (rootPartNumbers: string[]) => {
    const query = rootPartNumbers
      .map(
        (rootPartNumber) =>
          `rootPartNumbers=${encodeURIComponent(rootPartNumber)}`,
      )
      .join("&");
    return `/v1/cbo?${query}`;
  },
  getNotificationRequestStatus: (requestId: string) =>
    `/v1/suprsend/requests/${encodeURIComponent(requestId)}/`,
  sendBroadcast: "/v1/suprsend/send",
  refreshOutstanding: (customerId: string) =>
    `/v3/customers/${customerId}/outstanding`,
  voidOrderInvoice: (orderNo: string, invoiceNumber: string) =>
    `v1/orders/${encodeURIComponent(orderNo)}/invoices/${encodeURIComponent(invoiceNumber)}/void`,
  generateConsolidatedInvoice: (orderId: string) =>
    `v1/orders/${orderId}/invoices/consolidated/generate`,
  eventBus: "v1/eventBus",
};
export const porterEndpoints = {
  getPorterQuote: "/v1/porter/quote",
  bookPorter: "/v1/porter/book",
};
export default endpoints;
